import { render, staticRenderFns } from "./Start3.vue?vue&type=template&id=1152c87f&"
import script from "./Start3.vue?vue&type=script&lang=js&"
export * from "./Start3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports